module.exports = __webpack_public_path__ + "img/1.f64d647f.png";